import type { ProjectGetCommand, SpProjectGetWithUsersResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertNonEmptyString } from './_utils';

export class GetSpProjectWithUsersUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectGetCommand): Promise<SpProjectGetWithUsersResponse> {
    assertNonEmptyString(command.project_id, 'project_id');
    return this.repository.getSpProjectWithUsers(command);
  }
}


